export enum PayRunsCleverTapEvents {
  // PayRUns List
  webPayRunsListView = 'Web_Pay_Runs_List_View',
  webPayRunsExport = 'Web_Pay_Runs_Export',

  // Pay run configuration
  webPayRunsEditPayScheduleClick = 'Web_Pay_Runs_Edit_Pay_Schedule_Click',
  webPayRunsSetUpPayScheduleClick = 'Web_Pay_Runs_Set_Up_Pay_Schedule_Click',

  // Pay period review
  webPayPeriodReviewView = 'Web_Pay_Period_Review_View',
  webPayPeriodReviewBulkSubmit = 'Web_Pay_Period_Review_Bulk_Submit',
  webPayRunStatusChange = 'Web_Pay_Run_Status_Change',
  webPayRunSortByUse = 'Web_Pay_Run_Sort_By_Use',

  // Member review
  webPayRunMemberReviewView = 'Web_Pay_Run_Member_Review_View',
  webPayRunMemberReviewApproval = 'Web_Pay_Run_Member_Review_Approval',
  webPayRunMemberReportSent = 'Web_Pay_Run_Member_Report_Sent',

  // Jobs
  webPayRunJobStatusChange = 'Web_Pay_Run_Job_Status_Change',
  webPayRunJobReviewPanelView = 'Web_Pay_Run_Job_Review_Panel_View',
  webPayRunExplainJobCommissionView = 'Web_Pay_Run_Explain_Job_Commission_View',
  webPayRunExplainJobAddAdjustmentView = 'Web_Pay_Run_Explain_Job_Add_Adjustment_View',

  // Member history
  webPayRunMemberHistoryView = 'Web_Pay_Run_Member_History_View',
  webPayRunMemberHistoryNoteAction = 'Web_Pay_Run_Member_History_Note_Action',

  // Adjustments
  webPayRunAdjustmentTabView = 'Web_Pay_Run_Adjustment_Tab_View',
  webPayRunAddAdjustmentClick = 'Web_Pay_Run_Add_Adjustment_Click',
  webPayRunAdjustmentCreated = 'Web_Pay_Run_Adjustment_Created',
  webPayRunAdjustmentRemoved = 'Web_Pay_Run_Adjustment_Removed',
  webPayRunAdjustmentReviewClick = 'Web_Pay_Run_Adjustment_Review_Click',

  // Customize columns
  webCustomizeColumnsSaved = 'Web_Customize_Columns_Saved'
}
